import { Box, Typography } from "@mui/material";
import { BulkOrder } from "types/bulkOrder";
import { Modal } from "components/common/Modal";
import { useEffect, useMemo, useState } from "react";
import { useFetcher } from "react-router-dom";
import MultipleFormInputs from "./MultipleFormInputs";
import { useSWRConfig } from "swr";

interface WeightAndDimsModalProps {
  bulkOrder: BulkOrder | null;
  open: boolean;
  onClose: () => void;
}

const WeightAndDimsModal = ({ bulkOrder, open, onClose }: WeightAndDimsModalProps) => {
  const fetcher = useFetcher();
  const isSubmitting = fetcher.state === "submitting";
  const [wasSubmitting, setWasSubmitting] = useState(false);
  const { mutate } = useSWRConfig();
  const storageType = useMemo(() => {
    if (bulkOrder?.shippingMethod === "freight") return "Pallet";
    if (bulkOrder?.shippingMethod === "ground") return "Box";

    return null;
  }, [bulkOrder?.shippingMethod]);

  // Track when we start submitting
  useEffect(() => {
    if (fetcher.state === "submitting") {
      setWasSubmitting(true);
    }
  }, [fetcher.state]);

  // Close modal when submission is successful (action returns null on success)
  useEffect(() => {
    if (wasSubmitting && fetcher.state === "idle" && fetcher.data === null) {
      setWasSubmitting(false);
      mutate((key) => typeof key === "string" && key.startsWith("bulk_orders"), undefined, { revalidate: true });
      onClose();
    }
  }, [wasSubmitting, fetcher.state, fetcher.data, mutate, onClose]);

  return (
    <Modal open={open} setOpen={() => null} onClose={onClose} style={{ overflowY: "scroll", maxHeight: "90vh" }}>
      <fetcher.Form action={`/bulk-orders/${bulkOrder?.manifestId}/update`} method="put" id="edit-weight-dims-form">
        <Box p={1}>
          <Typography mt={1} variant="h5" component="h2" fontWeight={800}>
            {bulkOrder?.containers?.length ? "Edit" : "Add"} Weight and Dims
          </Typography>

          {(storageType === "Pallet" || storageType === "Box") && (
            <MultipleFormInputs storageType={storageType} bulkOrder={bulkOrder} isSubmitting={isSubmitting} />
          )}
        </Box>
      </fetcher.Form>
    </Modal>
  );
};

export default WeightAndDimsModal;
